var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Error_24",
    width: 100,
    height: 100,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,238,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-20, -19.25)",
    d: "M 3.209 35.5 C 2.592 35.5 2.04 35.181 1.732 34.647 C 1.423 34.113 1.423 33.475 1.732 32.940999999999995 L 18.523 3.858 C 18.831 3.324 19.383 3.005 20 3.005 C 20.617 3.005 21.169 3.324 21.477 3.8579999999999997 L 38.268 32.940999999999995 C 38.577 33.474999999999994 38.577 34.111999999999995 38.268 34.647 C 37.96 35.181 37.408 35.5 36.791000000000004 35.5 L 3.209 35.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(186,155,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-20, -19.25)",
    d: "M 20 3.506 C 20.209 3.506 20.73 3.565 21.044 4.109 L 37.835 33.192 C 38.149 33.736 37.94 34.217 37.835 34.398 C 37.73 34.578 37.419 35 36.791 35 L 3.209 35 C 2.581 35 2.269 34.578 2.165 34.397 C 2.06 34.216 1.851 33.735 2.165 33.190999999999995 L 18.956 4.109 C 19.27 3.564 19.791 3.506 20 3.506 M 20 2.506 C 19.257 2.506 18.514 2.8739999999999997 18.09 3.609 L 1.299 32.691 C 0.45 34.162 1.511 36 3.209 36 L 36.791000000000004 36 C 38.489000000000004 36 39.550000000000004 34.162 38.701 32.691 L 21.91 3.609 C 21.486 2.873 20.743 2.506 20 2.506 L 20 2.506 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 1.92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(54,64,77)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-20, -21.92)",
    d: "M 20 27.517999999999997 C 19.063325064286975 27.517999999999997 18.304 28.277325064286973 18.304 29.214 C 18.304 30.150674935713024 19.063325064286975 30.91 20 30.91 C 20.936674935713025 30.91 21.696 30.150674935713024 21.696 29.214 C 21.696 28.277325064286973 20.936674935713025 27.517999999999997 20 27.517999999999997 z M 18.643 12.929 L 21.357 12.929 L 21.357 25.143 L 18.643 25.143 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.9f816b36f8da93cf596d4c1c11270ff0.svg";
export { ForwardRef as ReactComponent };